import React, { Component } from 'react'
import axios from 'axios'
import Dropdown from 'react-bootstrap/Dropdown'
import DrawGraph from './DrawGraph'
import EventDataCon from './EventDataCon'
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

// Temporary switch: keep report downloads working while Hypoxic Burden is disabled.
const ENABLE_HYPOXIC_BURDEN = false

class ReportDropdown extends Component {
	constructor(props) {
		super(props)
		this.state = {
			start01: false,
			wait01: false,
			wait02: false,
			gragh_res: false,
			visible: "none",
			graphData: {},
			eventData: [],
			hypoxicBurden: null,
		}
	}

	CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
		<a
			href="/#/"
			ref={ref}
			onClick={(e) => {
				e.preventDefault();
				onClick(e);
			}}>
			{children}
			&#x25bc;
		</a>
	))

	saveGraph = async (graphData) => {
		let result = await axios.post('/graph', { graphData: graphData, account: this.props.account, time: (window.location.href[window.location.href.length - 1]) });
		//console.log(graphData);
		this.setState({ gragh_res: result.data.success })
	}
	savedata = (list) => {
		this.setState({
			eventData: list
		})
	}
	oknext01 = (bool) => {
		this.setState({
			wait01: bool
		})
	}
	oknext02 = (bool) => {
		this.setState({
			wait02: bool
		})
	}
	getReportValidationError = () => {
		const totalEpoch = Number(this.props.totalEpoch)
		if (!Number.isInteger(totalEpoch) || totalEpoch <= 0) {
			return '總 epoch 尚未載入完成'
		}

		const requiredEpochSeries = [
			['使用者睡眠分期', this.props.stage],
			['專家睡眠分期', this.props.modeArr],
			['使用者 Mixed Apnea', this.props.Mixed_Apnea_s],
			['使用者 Obstructive Apnea', this.props.Obstructive_Apnea_s],
			['使用者 Central Apnea', this.props.Central_Apnea_s],
			['使用者 Hypopnea', this.props.Hypopnea_s],
			['使用者 Arousal', this.props.arousal_s],
			['使用者 SpO2 Desat', this.props.spo2_s],
			['使用者 Limb', this.props.limb_r_s]
		]
		for (const [name, values] of requiredEpochSeries) {
			if (!Array.isArray(values) || values.length !== totalEpoch) {
				return `${name}資料尚未載入完成（${Array.isArray(values) ? values.length : 0}/${totalEpoch}）`
			}
		}

		if (!Array.isArray(this.props.msevent) || this.props.msevent.length < 7 ||
			this.props.msevent.slice(0, 7).some(row => !Array.isArray(row) || row.length < totalEpoch)) {
			return '專家事件資料尚未載入完成'
		}
		return null
	}

	render() {
		return (
			<>
				{this.state.start01 ? <DrawGraph
					stage={this.props.stage}
					psgFileId={this.props.psgFileId}
					visible={this.state.visible}
					saveGraph={this.saveGraph}
					all_event={this.props.all_event}
					arousal_s={this.props.arousal_s}
					spo2_s={this.props.spo2_s}
					Mixed_Apnea_s={this.props.Mixed_Apnea_s}
					Obstructive_Apnea_s={this.props.Obstructive_Apnea_s}
					Central_Apnea_s={this.props.Central_Apnea_s}
					Hypopnea_s={this.props.Hypopnea_s}
					limb_r_s={this.props.limb_r_s}
					modeArr={this.props.modeArr}
					msevent={this.props.msevent}
					wait01={this.state.wait01}
					oknext01={this.oknext01}
					gragh_res={this.gragh_res}
				/> : <></>}
				{this.state.start01 ? <EventDataCon
					stage={this.props.stage}
					eventData={this.state.eventData}
					savedata={this.savedata}
					all_event={this.props.all_event}
					arousal_s={this.props.arousal_s}
					spo2_s={this.props.spo2_s}
					Mixed_Apnea_s={this.props.Mixed_Apnea_s}
					Obstructive_Apnea_s={this.props.Obstructive_Apnea_s}
					Central_Apnea_s={this.props.Central_Apnea_s}
					Hypopnea_s={this.props.Hypopnea_s}
					limb_r_s={this.props.limb_r_s}
					msevent={this.props.msevent}
					psgFileId={this.props.psgFileId}
					masterEvents={this.props.masterEvents}
					totalEpoch={this.props.totalEpoch}
					spo2_deast={this.props.spo2_deast}
					spo2_respiratory={this.props.spo2_respiratory}
					modeArr={this.props.modeArr}
					wait02={this.state.wait02}
					oknext02={this.oknext02}
					hypoxicBurden={this.state.hypoxicBurden}
				/> : <></>}
				<Dropdown onSelect={async (item) => {
					if (item === 'workshop') {

						const accountResult = await axios.post('/ajax_who_am_i', {});
						const account = accountResult.data.account;
						const reportValidationError = this.getReportValidationError()
						if (reportValidationError !== null) {
							alert(`報告資料尚未準備完成：${reportValidationError}`)
							return
						}
						// if (this.props.psgFileId === 10 && (window.location.href[window.location.href.length - 1]) == 2) {
						// 	alert("第二次判讀報告將於7/11後提供下載")
						// 	return;
						// }
						// 2025工作坊 MSLT沒有提供一致性比對，但可以下載睡眠檢查報告
						if (this.props.psgFileId === 11) {
							alert("本次並無提供MSLT一致性比對，您可以至「產生報告」→「下載睡眠檢查報告」或返回上一頁");
							return; // 如果帳號不是 setans，就中斷後續所有操作
						}
						let hypoxicBurden = null
						if (ENABLE_HYPOXIC_BURDEN && this.props.psgFileId === 5) {
							try {
								const hypoxicBurdenResult = await axios.post('/calculate_hypoxic_burden', {
									account: account,
									psgFileId: this.props.psgFileId,
									scoringTimes: Number(window.location.href[window.location.href.length - 1])
								})
								if (!hypoxicBurdenResult.data.success ||
									hypoxicBurdenResult.data.hypoxicBurden === null) {
									throw new Error(hypoxicBurdenResult.data.msg || 'Hypoxic Burden is unavailable')
								}
								hypoxicBurden = hypoxicBurdenResult.data.hypoxicBurden
							} catch (error) {
								const message = error.response && error.response.data && error.response.data.msg
									? error.response.data.msg
									: error.message
								alert('Hypoxic Burden 計算失敗：' + message)
								return
							}
						}
						this.setState({
							start01: false,
							wait01: false,
							wait02: false,
							gragh_res: false,
							graphData: {},
							eventData: [],
							hypoxicBurden: hypoxicBurden
						}, () => this.setState({ start01: true }))
						// 繪製圖片傳至後端 (不知道會不會出現canvas還沒畫完的情形?)
						this.setState({ visible: "none" }); // 方便繪製的工具，完成後須註解
						const loop = () => {
							if (this.state.wait01 === true && this.state.wait02 === true && this.state.gragh_res === true) {
								let xhttp = new XMLHttpRequest();// 產生報告並下載
								xhttp.responseType = 'blob';
								xhttp.onload = async () => {
									let blob = xhttp.response;
									console.log('word response status:', xhttp.status, 'blob size:', blob?.size)
									if (xhttp.status === 200) {
										if (blob && blob.size > 0) {
											let element = document.createElement('a');
											element.setAttribute('href', URL.createObjectURL(blob));
											element.setAttribute('download', String(this.props.account) + "_第" + String((window.location.href[window.location.href.length - 1])) + '次.docx');
											document.body.appendChild(element);
											element.click();
										} else {
											alert('下載失敗：伺服器回傳空白文件');
										}
									} else {
										const serverMessage = blob && typeof blob.text === 'function'
											? (await blob.text()).trim()
											: ''
										alert('下載失敗：伺服器錯誤 ' + xhttp.status +
											(serverMessage ? '\n' + serverMessage : ''));
									}
								}
								xhttp.onerror = () => {
									console.error('word request failed (network/CORS error)')
									alert('下載失敗：網路連線錯誤或 CORS 問題');
								}
								let data = { account: this.props.account, psgfileid: this.props.psgFileId, ev_data: this.state.eventData, time: (window.location.href[window.location.href.length - 1]) };
								let url = "https://scoring.ncbci.org/word";
								xhttp.open("POST", url, true);
								xhttp.setRequestHeader("Content-type", "application/json");
								xhttp.send(JSON.stringify(data));
								//this.setState({start01: false})
							} else {
								window.setTimeout(loop, 100);
							}
						}
						window.setTimeout(loop, 100);
						// alert("一致性結果報告修復中，修復完畢會再寄信通知大家，造成您的不便十分抱歉!");
						// alert("此功能將於 7/26 以前開放!");
					}
					else if (item === 'sleep_report') {
						// 2025工作坊 MSLT沒有提供一致性比對，但可以下載睡眠檢查報告
						if (this.props.psgFileId == 11) {
							window.location.href = 'https://scoring.ncbci.org/download/sleep_report';
						} else {
							alert("尚未開放的功能喔~\n敬請期待!");
						}
					}
					else if (item === 'golden') {
						const valueMapping = {
							0: 'W',
							1: 'N1',
							2: 'N2',
							3: 'N3',
							'-1': 'REM',
							'-2': 'RWA',
						};
						const convertStage = (value) => valueMapping[value];
						const worksheet = XLSX.utils.aoa_to_sheet([['Epoch', 'Stage'], ...(this.props.modeArr).map((value, index) => [index + 1, convertStage(value)])]);
						const workbook = XLSX.utils.book_new();
						XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
						const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
						const blob = new Blob([wbout], { type: 'application/octet-stream' });
						saveAs(blob, 'golden.xlsx');
					}
				}}>
					<Dropdown.Toggle as={this.CustomToggle} id="account-dropdown">
						產生報告&nbsp;
					</Dropdown.Toggle>
					<Dropdown.Menu>
						<Dropdown.Item eventKey={'workshop'} style={{ color: 'black' }}>
							工作坊報告
						</Dropdown.Item>
						<Dropdown.Item eventKey={'sleep_report'} style={{ color: 'black' }}>
							睡眠檢查報告
						</Dropdown.Item>
						{/* 因為劉老師需要每年度的 golden ，計算 golden 的地方在前端沒有存到資料庫，
						    所以需要加上下載 golden 的功能，只開發給開發者使用，不給學員 */}
						{/* <Dropdown.Item eventKey={'golden'} style={{color: 'black'}}>
							下載 golden
						</Dropdown.Item> */}
					</Dropdown.Menu>
				</Dropdown>
			</>
		)
	}
}

export default ReportDropdown
